import wrapper from 'wrapper';

class Modal {
    constructor(filters, allAges) {
        this.filters = filters; // To get card order after filtering
        this.vocabs = wrapper.vjConfigObject.vocab;
        this.modalContainer = wrapper.select('.modal-container');
        this.isShadowDom = wrapper.select('.bbc-news-vj-shadow-dom');
        this.isModalOpen = false;
        this.cardsListNode = wrapper.select('.cards__list');
        this.totalClickCount = 0;
        this.isKeyPressEventAdded = false;
        this.allAges = allAges;
    }

    createModal(scrollPosition, clickedCardId, isAmp) {
        this.cardNodes = wrapper.selectAll('.filtered .card');

        // This holds the list of card ids for the list of cards shown
        this.cardOrder = this.filters.getCardOrder();

        // This holds the position in the card order you are e.g you click an
        // arrow button this is incremented/decremented
        this.currentCardIndex = this.cardOrder.indexOf(clickedCardId) || 0;

        this.changeModalPositionForAmp(isAmp);

        if (!this.isModalOpen) {
            this.modal = document.createElement('aside');
            this.modalCloseButton = document.createElement('button');
            this.modalHeader = document.createElement('header');
            this.modalName = document.createElement('h3');
            this.modalImage = document.createElement('img');
            this.modalStrapline = document.createElement('div');
            this.modalDetails = document.createElement('div');
            this.modalMainText = document.createElement('div');
            this.modalRelatedArticles = document.createElement('div');
            this.modalCloseButtonHidden = document.createElement('button');

            this.modal.className = 'modal';
            this.modalCloseButton.className = 'modal__close-button';
            this.modalCloseButton.innerHTML = `
            <span class="off-screen">
                ${__('pop-out_1_modal_helper_text')} ${__('pop-out_1_close_button_text')}
            </span>
            `;
            this.modalCloseButtonHidden.innerHTML = __('pop-out_1_close_button_text');
            this.modalCloseButtonHidden.className = 'skip-link';
            this.modalHeader.className = 'modal__header';
            this.modalName.className = 'modal__header__name';
            this.modalImage.className = 'modal__header__image';
            this.modalStrapline.className = 'modal__header__strapline';
            this.modalDetails.className = 'modal__details';
            this.modalMainText.className = 'modal__main-text';
            this.modalRelatedArticles.className = 'modal__main-text';

            this.modalContainer.style.display = 'block';

            this.updateModal();

            this.modal.appendChild(this.modalCloseButton);

            if (!(this.cardOrder.length === 1)) this.createArrowButtons();

            this.modal.appendChild(this.modalHeader);
            this.modal.appendChild(this.modalDetails);

            this.modalHeader.appendChild(this.modalName);
            this.modalHeader.appendChild(this.modalImage);
            this.modalHeader.appendChild(this.modalStrapline);

            this.modalDetails.appendChild(this.modalMainText);
            this.modalDetails.appendChild(this.modalRelatedArticles);

            this.modal.appendChild(this.modalCloseButtonHidden);

            this.modalContainer.appendChild(this.modal);

            this.modalCloseButton.addEventListener('click', () => {
                this.closeModal();
            });

            // Event listener for the hidden button,
            // serves as a skip link for a11y.
            this.modalCloseButtonHidden.addEventListener('click', () => {
                this.closeModal();
            });

            if (this.isShadowDom) {
                // Programatically setting the cps page orb-nav-bar with lower z-index to appear behind the modal.
                if (document.getElementById('orb-header')) {
                    document.getElementById('orb-header').style.zIndex = 0;
                }
                // Preventing the user from scrolling when a modal is open in ShadowDom.
                document.querySelector('html, body').style.overflow = 'hidden';
            }
            else {
                this.modal.style.top = `${scrollPosition}px`;
                this.modal.style.margin = '0 auto';
                this.adjustListPaddingForIframe();
            }

            this.modalContainer.addEventListener('click', e => {
                this.checkFocusAndCloseModal(this.modal, e.target);
            });

            this.modalCloseButton.focus();

            this.disableCardAccess();

            this.isModalOpen = true;
        }
    }

    updateModal() {
        this.setVisitedState(this.currentCardIndex);
        this.setLiveRegionText();
        this.setModalText();
    }

    setVisitedState(index) {
        this.cardNodes[index].classList.add('card--visited');
    }

    setLiveRegionText() {
        const liveRegion = wrapper.select('.modal-live-region');
        liveRegion.innerHTML = `${this.getFullNameFromCard(this.currentCardNumber())}`;
    }

    setModalText() {
        const position = this.currentCardNumber();
        const paragraphKeys = new RegExp(`card_${position}_par\\d`);
        const age = this.allAges[`person_${position}`];

        this.modalName.innerHTML = `${this.getFullNameFromCard(position)}`;
        this.modalStrapline.innerHTML = age
            ? `<span class="modal__header__strapline__age">
                    ${__('pop-out_1_age_text')} ${age}
                </span>` : '';
        if (__(`card_${position}_tagline`)) {
            const profession = document.createElement('span');
            profession.className = 'modal__header__strapline__tagline';
            profession.innerHTML = __(`card_${position}_tagline`);
            this.modalStrapline.appendChild(profession);
        }
        this.modalImage.setAttribute('src', `${__(`card_${position}_image_url`)}`);
        this.modalImage.setAttribute('alt', `${__(`card_${position}_portrait_alt_text`)}`);
        this.modalRelatedArticles.innerHTML = __(`card_${position}_related_article1_story_url`)
            ? `<h4 class="modal__main-text__header">${__(`card_${position}_related_articles_header`)}</h4>
               <a href="${__(`card_${position}_related_article1_story_url`)}"
                  target="_blank">
                    ${__(`card_${position}_related_article1_link_text`)}
               </a>`
            : '';
        this.modalMainText.innerHTML = '';
        Object.keys(this.vocabs).forEach(key => {
            if (key.toString().match(paragraphKeys)) {
                const headerRegexp = /^####(.*)$/;
                const headerMatches = this.vocabs[key].match(headerRegexp);
                if (headerMatches) {
                    this.modalMainText.innerHTML += `<h4 class="modal__main-text__header">${headerMatches[1]}</h4>`;
                }
                else {
                    this.modalMainText.innerHTML += `<p>${this.convertMarkdownToMarkup(this.vocabs[key])}</p>`;
                }
            }
        });
    }

    createArrowButtons() {
        this.leftArrow = document.createElement('button');
        this.rightArrow = document.createElement('button');
        const buttonContainer = document.createElement('div');

        buttonContainer.setAttribute('class', 'modal__button-container');
        this.leftArrow.setAttribute('class', 'modal__button-container--left-arrow');
        this.rightArrow.setAttribute('class', 'modal__button-container--right-arrow');
        this.leftArrow.setAttribute('aria-label', __('pop-out_1_arrow_left_aria_label'));
        this.rightArrow.setAttribute('aria-label', __('pop-out_1_arrow_right_aria_label'));

        if (this.currentCardIndex === 0) {
            this.leftArrow.disabled = true;
            this.leftArrow.setAttribute('aria-hidden', 'true');
        }
        else if (this.currentCardIndex === this.cardOrder.length - 1) {
            this.rightArrow.disabled = true;
            this.rightArrow.setAttribute('aria-hidden', 'true');
        }

        this.leftArrow.addEventListener('click', () => {
            this.setArrowButtonState('left', this.leftArrow, this.rightArrow);
            this.updateOnArrowClick();
        });

        this.rightArrow.addEventListener('click', () => {
            this.setArrowButtonState('right', this.rightArrow, this.leftArrow);
            this.updateOnArrowClick();
        });

        // Arrow keypress to navigate with keyboard
        if (!this.isKeyPressEventAdded) {
            document.addEventListener('keyup', this.changeModalOnKeypress.bind(this));
            // window.onkeyup = (e) => this.changeModalOnKeypress(e);
            this.isKeyPressEventAdded = true;
        }

        buttonContainer.appendChild(this.leftArrow);
        buttonContainer.appendChild(this.rightArrow);
        this.modal.appendChild(buttonContainer);
    }

    setArrowButtonState(direction, pressedButton, otherButton) {
        this.updateCardIndex(direction);
        if (this.currentCardIndex === this.cardOrder.length - 1 || this.currentCardIndex === 0) {
            pressedButton.disabled = true; //eslint-disable-line
            pressedButton.setAttribute('aria-hidden', 'true');
        }
        otherButton.disabled = false; //eslint-disable-line
        otherButton.setAttribute('aria-hidden', 'false');
    }

    updateOnArrowClick() {
        this.updateModal();
        this.cardsVisitedBeforeClose += 1;
    }

    changeModalOnKeypress(e) {
        if (this.isModalOpen) {
            if (e.code === 'ArrowRight' && this.currentCardIndex < this.cardOrder.length - 1) {
                this.setArrowButtonState('right', this.rightArrow, this.leftArrow);
                this.updateOnArrowClick();
                this.rightArrow.focus();
                if (this.currentCardIndex === this.cardOrder.length - 1) {
                    this.leftArrow.focus();
                }
                else {
                    this.rightArrow.focus();
                }
            }
            if (e.code === 'ArrowLeft' && this.currentCardIndex > 0) {
                this.setArrowButtonState('left', this.leftArrow, this.rightArrow);
                this.updateOnArrowClick();
                if (this.currentCardIndex === 0) {
                    this.rightArrow.focus();
                }
                else {
                    this.leftArrow.focus();
                }
            }
        }
    }

    // Check if the focused element is part of the modal,
    // so that when the modal loses focus to one of its child elements it's not closed down.
    checkFocusAndCloseModal(modal, target) {
        if (this.isModalOpen) {
            if (!wrapper.select('.modal').contains(target)) {
                this.closeModal();
            }
        }
    }

    closeModal() {
        if (this.isShadowDom) {
            // Return the orb-nav-bar's z-index back to how it was before
            if (document.getElementById('orb-header')) {
                document.getElementById('orb-header').style.zIndex = 999;
            }
            document.querySelector('html, body').style.overflow = 'auto';
        }
        else {
            this.adjustListPaddingForIframe();
        }

        this.enableCardAccess();

        this.modalContainer.innerHTML = '';
        this.modalContainer.style.display = 'none';
        this.cardNodes[this.currentCardIndex].focus();
        this.cardNodes[this.currentCardIndex].setAttribute(
            'aria-label',
            `${this.getFullNameFromCard(this.currentCardNumber())}, ${__('card_1_button_text_visited')}`,
        );

        this.isModalOpen = false;
    }

    //  Adds padding to the bottom of the iFrame,
    //  so that when one of the last cards are clicked,
    //  the modal is not getting cut off by the end of the iFrame.
    adjustListPaddingForIframe() {
        if (this.modal) {
            const modalBottomPos = this.modal.getBoundingClientRect().bottom;
            const listBottomPos = this.cardsListNode.getBoundingClientRect().bottom;
            const diff = listBottomPos - modalBottomPos;
            if (diff < 0) {
                this.cardsListNode.style.paddingBottom = `${Math.abs(diff)}px`;
            }
            else {
                this.cardsListNode.style.padding = 0;
            }
        }
    }

    // Removes the tabIndex from the cards when the modal is open to prevent excessive keyboard navigation.
    disableCardAccess() {
        Array.from(this.cardNodes).forEach(articleNode => {
            articleNode.removeAttribute('tabindex');
            articleNode.removeAttribute('role');
            this.cardsListNode.setAttribute('aria-hidden', 'true');
        });
    }

    enableCardAccess() {
        Array.from(this.cardNodes).forEach(articleNode => {
            articleNode.setAttribute('tabindex', 0);
            articleNode.setAttribute('role', 'button');
            this.cardsListNode.removeAttribute('aria-hidden');
        });
    }

    updateCardIndex(direction) {
        this.currentCardIndex = direction === 'left' ? this.currentCardIndex - 1 : this.currentCardIndex + 1;
    }

    getFullNameFromCard(cardId) {
        return `${__(`card_${cardId}_firstname`) || ''} ${__(`card_${cardId}_secondname`) || ''}`;
    }

    currentCardNumber() {
        return this.cardOrder[this.currentCardIndex];
    }

    // Position fixed causes the modal to behave weirdly in AMP,
    // however position absolute works perfectly fine,
    // therefore we set it here and do a few positioning adjustments in app.js
    changeModalPositionForAmp(isAmp) {
        if (isAmp) this.modalContainer.style.position = 'absolute';
    }

    // Ugly hack until we can get inline-links into vocab json
    /** @function
     * @name convertMarkdownToMarkup
     * Takes a string and globally replaces markdown with HTML
     * @param {string} str
     * @returns {string}
     * @example
     * // returns '<span class="highlight">Highlighted text</span> and an <a href="https://www.bbc.com/hindi" target="_top">inline link</a> too'
     * convertMarkdownToMarkup('**Highlighted text** and an [inline link](https://www.bbc.com/hindi) too');
     */
    convertMarkdownToMarkup(str) {
        let text = str;
        const linksRegexp = /\[(.+?)\]\(((http|https):\/\/.+?)\)/sg;
        const highlightsRegexp1 = /\*{2}(.+?)\*{2}/sg;
        text = text.replace(linksRegexp, '<a href="$2" target="_top">$1</a>');
        text = text.replace(highlightsRegexp1, '<span class="modal__highlight">$1</span>');
        return text;
    }
}

export default Modal;
